<div>
  <div class="card-body">
    @if(productForm) {
    <form [formGroup]="productForm">
      <!-- Add global validation error messages -->
      <div *ngIf="zodErrors().length > 0" class="validation-errors">
        <mat-error *ngFor="let error of zodErrors()">
          <mat-icon>error_outline</mat-icon>
          {{ error.message }}
        </mat-error>
      </div>

      <div class="col-md-12 section-group">
          <h6 class="section-title">Main</h6>
          <div class="row">
            @if (productNameControl) {
            <mat-form-field [class]="commonNameControl ? 'col-md-6' : 'col-md-12'">
              <mat-label>Product name</mat-label>
              <input
                matInput
                placeholder="Product Name"
                [formControl]="productNameControl"
                required
              />
              <!-- The uploaded image filename is built from this name, and these
                   characters end or redirect a URL path, so the image link breaks. -->
              <mat-hint>Avoid # ? % / \ &mdash; these characters break the product image link.</mat-hint>
              <mat-error *ngIf="shouldShowError(productForm.get('product_name'))">
                {{ getErrorMessage(productForm.get('product_name')) }}
              </mat-error>
            </mat-form-field>
            } @if (commonNameControl) {
            <!-- Optional. When filled, storefront product cards show
                 "<common name> (<product name>)". -->
            <mat-form-field class="col-md-6">
              <mat-label>Common name</mat-label>
              <input
                matInput
                placeholder="e.g. Black Arrow Tetra"
                [formControl]="commonNameControl"
              />
              <mat-hint>Optional. Cards show "Common name (Product name)".</mat-hint>
              <mat-error *ngIf="shouldShowError(productForm.get('common_name'))">
                {{ getErrorMessage(productForm.get('common_name')) }}
              </mat-error>
            </mat-form-field>
            } @if (originCountryIso2Control) {
            <div class="col-md-4">
              <!-- Narrows the vendor list; opens on the vendor's own country. -->
              <fh-form-autocomplete
                [options]="originCountryOptions()"
                label="Vendor Country"
                [formControl]="originCountryIso2Control"
                [required]="true"
                (selectionChange)="onOriginCountryChange()"
              />
            </div>
            } @if (vendorIdControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="vendorOptions()"
                label="Vendor"
                [formControl]="vendorIdControl"
                [required]="true"
                (selectionChange)="onVendorSelectionChange($event)"
              />
            </div>
            } @if (qtyControl) {
            <mat-form-field class="col-md-4">
              <mat-label>Quantity</mat-label>
              <input
                matInput
                placeholder="Quantity"
                [formControl]="qtyControl"
                required
                type="number"
              />
              <mat-error *ngIf="shouldShowError(productForm.get('qty'))">
                {{ getErrorMessage(productForm.get('qty')) }}
              </mat-error>
            </mat-form-field>
            } @if (categoryIdControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="categoryOptions()"
                label="Category"
                [formControl]="categoryIdControl"
                [required]="true"
                (selectionChange)="onCategorySelectionChange($any($event))"
              />
            </div>
            } @if (subcategoryIdControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="subCategoryOptions()"
                label="Sub-Category"
                [formControl]="subcategoryIdControl"
                [required]="true"
                (selectionChange)="onSubcategorySelectionChange($any($event))"
              />
            </div>
            } @if (subsubcategoryIdControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="subSubCategoryOptions()"
                label="Sub Sub-Category"
                [formControl]="subsubcategoryIdControl"
              />
            </div>
            } @if (moreDescriptionControl) {
            <div class="col-md-12 mt-2">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <strong>Product Description</strong>
                @if (minSizeControl) {
                <button
                  type="button"
                  mat-stroked-button
                  color="primary"
                  [disabled]="isGeneratingDescription()"
                  (click)="generateDescription()"
                  style="font-size: 0.8rem; height: 32px; line-height: 32px;"
                >
                  @if (isGeneratingDescription()) {
                  <mat-spinner diameter="16" style="display:inline-block; vertical-align:middle; margin-right:6px;"></mat-spinner>
                  Generating...
                  } @else {
                  ✨ Generate with AI
                  }
                </button>
                }
              </div>
              <angular-editor
                [formControl]="moreDescriptionControl"
                [placeholder]="'More Description*'"
                [config]="editorConfig"
              ></angular-editor>
              @if (moreDescriptionControl.invalid && (moreDescriptionControl.dirty || moreDescriptionControl.touched)) {
              <mat-error>More Description is required</mat-error>
              }
              <br />
            </div>
            }
          </div>
        </div>
 @if (minSizeControl || maxSizeControl || temperamentControl || waterConditionControl || wysiwygControl) {
        <div class="col-md-12 section-group">
          <h6 class="section-title">Product Attributes</h6>
          <div class="row">
            @if (minSizeControl) {
            <mat-form-field class="col-md-12">
              <mat-label>Minimum Size</mat-label>
              <input matInput placeholder="In cms" [formControl]="minSizeControl" type="number" />
              @if(minSizeControl.invalid && (minSizeControl.dirty || minSizeControl.touched)) {
              <mat-error>Minimum Size is required</mat-error>
              }
            </mat-form-field>
            } @if (maxSizeControl) {
            <mat-form-field class="col-md-12">
              <mat-label>Maximum Size</mat-label>
              <input matInput placeholder="In cms" [formControl]="maxSizeControl" type="number" />
              @if(maxSizeControl.invalid && (maxSizeControl.dirty || maxSizeControl.touched)) {
              <mat-error>Maximum Size is required</mat-error>
              }
            </mat-form-field>
            } @if (temperamentControl) {
            <div class="col-md-12">
              <fh-form-autocomplete
                [options]="temperamentOptions"
                label="Temperament"
                [formControl]="temperamentControl"
              />
            </div>
            } @if (waterConditionControl) {
            <div class="col-md-12">
              <fh-form-autocomplete
                [options]="waterConditionOptions"
                label="Water Condition"
                [formControl]="waterConditionControl"
              />
            </div>
            } @if (wysiwygControl) {
            <div class="col-md-12">
              <fh-form-autocomplete
                [options]="wysiwygOptions"
                label="WYSIWYG"
                [formControl]="wysiwygControl"
              />
            </div>
            }
          </div>
        </div>
        } @if (isPromotedControl || isFeaturedControl || isRareFishControl || isPreOrderControl || isRequestQuoteControl || productExpiryControl || statusControl) {
        <div class="col-md-12 section-group">
          <h6 class="section-title">Others</h6>
          <div class="row">
            @if (isPromotedControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="booleanOptions"
                label="Promoted"
                [formControl]="isPromotedControl"
              />
            </div>
            } @if (isFeaturedControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="booleanOptions"
                label="Is Featured"
                [formControl]="isFeaturedControl"
                [required]="true"
              />
              @if(isFeaturedControl.invalid && (isFeaturedControl.dirty || isFeaturedControl.touched)) {
              <mat-error>Is Featured is required</mat-error>
              }
            </div>
            } @if (isRareFishControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="booleanOptions"
                label="Is Rare Fish"
                [formControl]="isRareFishControl"
                [required]="true"
              />
              @if(isRareFishControl.invalid && (isRareFishControl.dirty || isRareFishControl.touched)) {
              <mat-error>Is Rare Fish is required</mat-error>
              }
            </div>
            } @if (isPreOrderControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="booleanOptions"
                label="Is Pre-Order"
                [formControl]="isPreOrderControl"
              />
              @if(isPreOrderControl.invalid && (isPreOrderControl.dirty || isPreOrderControl.touched)) {
              <mat-error>Is Pre-Order is required</mat-error>
              }
            </div>
            } @if (isRequestQuoteControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="booleanOptions"
                label="Request Quote"
                [formControl]="isRequestQuoteControl"
              />
              @if (isRequestQuoteControl.value) {
                <mat-hint class="text-xs text-amber-600">Price fields will be set to Not Applicable</mat-hint>
              }
            </div>
            } @if (productExpiryControl) {
            <mat-form-field class="col-md-4">
              <mat-label>Expiry Date</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                [formControl]="productExpiryControl"
                [min]="minDate"
                [max]="maxDate"
              />
              <mat-hint>{{ productExpiryHintText }}</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            } @if (statusControl) {
            <div class="col-md-4">
              <fh-form-autocomplete
                [options]="statusOptions()"
                label="Visibility"
                [formControl]="statusControl"
              />
            </div>
            }
          </div>
        </div>
        } @if (tankBreadthControl || tankHeightControl || tankLengthControl || capacityControl) {
        <div class="col-md-12 section-group">
          <h6 class="section-title">Tank Dimensions</h6>
          <div class="row">
            @if(tankBreadthControl) {
            <mat-form-field class="col-md-4">
              <mat-label>Breadth in cms</mat-label>
              <input
                matInput
                placeholder="Breadth"
                [formControl]="tankBreadthControl"
                type="number"
                required
              />
              @if (tankBreadthControl.invalid && (tankBreadthControl.dirty || tankBreadthControl.touched)) {
              <mat-error>Breadth is required</mat-error>
              }
            </mat-form-field>
            } @if(tankHeightControl) {
            <mat-form-field class="col-md-4">
              <mat-label>Height in cms</mat-label>
              <input
                matInput
                placeholder="Height"
                [formControl]="tankHeightControl"
                required
                type="number"
              />
              @if (tankHeightControl.invalid && (tankHeightControl.dirty || tankHeightControl.touched)) {
              <mat-error>Height is required</mat-error>
              }
            </mat-form-field>
            } @if(tankLengthControl) {
            <mat-form-field class="col-md-4">
              <mat-label>Length in cms</mat-label>
              <input
                matInput
                placeholder="Length"
                [formControl]="tankLengthControl"
                required
                type="number"
              />
              @if (tankLengthControl.invalid && (tankLengthControl.dirty || tankLengthControl.touched)) {
              <mat-error>Length is required</mat-error>
              }
            </mat-form-field>
            } @if(capacityControl) {
            <mat-form-field class="col-md-4">
              <mat-label>Capacity in gallons</mat-label>
              <input
                matInput
                placeholder="Capacity"
                [formControl]="capacityControl"
                required
                type="number"
              />
              @if (capacityControl.invalid && (capacityControl.dirty || capacityControl.touched)) {
              <mat-error>Capacity is required</mat-error>
              }
            </mat-form-field>
            }
          </div>
        </div>
        } @if (aiTagsControl) {
        <div class="col-md-12 section-group">
          <h6 class="section-title">AI Tags</h6>
          <fh-ai-tag-select
            [vocabulary]="aiTagVocabulary"
            label="AI Tags"
            [formControl]="aiTagsControl"
          />
        </div>
        } @if(mediaPickerControl) {
        <div class="col-md-12 section-group">
          <h6 class="section-title">Media</h6>
          <fh-media-picker [formControl]="mediaPickerControl"></fh-media-picker>
        </div>
        }
    </form>
    }

    <!-- Destination countries section -->
    <div class="col-md-12 country-specific-section mt-4">
      @if (countriesLoading()) {
      <div
        class="country-status"
        style="display:flex;align-items:center;gap:12px;padding:16px 0;color:#555;"
      >
        <mat-spinner diameter="24"></mat-spinner>
        <span>Loading destination countries…</span>
      </div>
      } @else if (countriesLoadFailed()) {
      <div
        class="country-status"
        style="display:flex;align-items:center;gap:12px;padding:16px 0;color:#b00020;"
      >
        <span>Couldn't load destination countries.</span>
        <button
          type="button"
          (click)="retryLoadCountries()"
          style="border:1px solid currentColor;background:transparent;color:inherit;padding:4px 12px;border-radius:4px;cursor:pointer;"
        >
          Retry
        </button>
      </div>
      } @else if (countrySpecificForm) { @if (destinationCountries().length === 0) {
      <div class="country-status" style="padding:16px 0;color:#555;">
        No destination countries are configured.
      </div>
      } @else {
      <mat-accordion class="country-sections" [formGroup]="countrySpecificForm" multi>
        <!-- Active Destinations -->
        @if (getSelectedCountries().length > 0) {
        <div class="destination-group">
          <h4 class="section-title">Country Specific Pricing, Delivery &amp; Variations</h4>
          @for (country of getSelectedCountries(); track country.iso2) {
          <mat-expansion-panel 
            [expanded]="isCountryExpanded(country.iso2)" 
            (opened)="onPanelOpened(country.iso2)"
            (closed)="onPanelClosed(country.iso2)"
            class="mb-2"
          >
            <mat-expansion-panel-header class="py-2">
              <mat-panel-title class="country-panel-title">
                <div class="flex items-center justify-between w-full">
                  <div class="flex items-center gap-2">
                    <mat-checkbox
                      [checked]="isCountrySelected(country.iso2)"
                      (change)="onDestinationCountryChange($event, country.iso2)"
                      (click)="$event.stopPropagation()"
                      color="primary"
                    >
                      {{ country.name }} ({{ country.currency }}) 
                    </mat-checkbox>
                    @if (marketBlocked(country.iso2)) {
                    <span class="text-sm text-gray-500">{{ marketBlockText(country.iso2) }} - untick to save</span>
                    }
                  </div>
                  @if (isCountrySelected(country.iso2) && isCountryFormInvalid(country.iso2)) {
                    <div class="validation-hint">
                      <mat-icon class="error-icon">warning</mat-icon>
                      <span class="error-text">Needs info</span>
                    </div>
                  }
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            @if (isCountrySelected(country.iso2)) {
            <div class="country-section py-3" [formGroupName]="country.iso2">
              <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Display Price</mat-label>
                  <input matInput formControlName="displayPrice" type="number"
                    [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                  @if (isRequestQuoteControl?.value) {
                    <mat-hint class="text-amber-600">Not Applicable</mat-hint>
                  }
                  <mat-error *ngIf="shouldShowError(countrySpecificForm.get(country.iso2)?.get('displayPrice') || null)">
                    {{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get('displayPrice') || null) }}
                  </mat-error>
                </mat-form-field>

                <!-- Delivery charge and the walk-in switch sit together: ticking it
                     zeroes and disables the charge, so they read as one control
                     rather than two that happen to be near each other. -->
                <div class="flex items-start gap-3">
                  <div class="flex-1 min-w-0">
                @if (deliveryZonesFor(country.iso2).length > 0) {
                <!-- US / MY: charged by the customer's shipping-address state, per zone. -->
                <div class="flex flex-col gap-1">
                  @for (z of deliveryZonesFor(country.iso2); track z.zone) {
                  <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
                    <mat-label>{{ z.label }}</mat-label>
                    <input matInput [formControlName]="zoneControlName(z.zone)" type="number"
                      [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                    <mat-hint>{{ isRequestQuoteControl?.value ? 'Not Applicable' : z.states }}</mat-hint>
                    <mat-error *ngIf="shouldShowError(countrySpecificForm.get(country.iso2)?.get(zoneControlName(z.zone)) || null)">
                      {{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get(zoneControlName(z.zone)) || null) }}
                    </mat-error>
                  </mat-form-field>
                  }
                </div>
                } @else {
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Delivery Charge</mat-label>
                  <input matInput formControlName="deliveryCharge" type="number"
                    [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                  @if (isRequestQuoteControl?.value) {
                    <mat-hint class="text-amber-600">Not Applicable</mat-hint>
                  }
                  <mat-error *ngIf="shouldShowError(countrySpecificForm.get(country.iso2)?.get('deliveryCharge') || null)">
                    {{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get('deliveryCharge') || null) }}
                  </mat-error>
                </mat-form-field>
                }
                  </div>
                  <mat-checkbox formControlName="walkInOnly" class="mt-3 shrink-0">
                    Walk in Only
                  </mat-checkbox>
                </div>

                <!-- Transhipper markup is set per product option, below. -->
              </div>

              <div class="mt-3">
                <div class="flex justify-between items-center mb-2">
                  <span class="text-sm font-medium">Product Options</span>
                  <span class="text-xs text-gray-500">(At least one required)</span>
                </div>
                <div class="product-options">
                  <fh-product-options
                      [formArray]="getProductOptionsArray(country.iso2)"
                    [markupForSize]="markupForSize(country.iso2)"
                    [isRequestQuote]="isRequestQuoteControl?.value ?? false"
                    (addOption)="addProductOption(country.iso2)"
                    (removeOption)="removeProductOption(country.iso2, $event)"
                  >
                  </fh-product-options>
                </div>
              </div>
            </div>
            }
          </mat-expansion-panel>
          }
        </div>
        }

        <!-- Available Destinations -->
        @if (getUnselectedCountries().length > 0) {
        <div class="destination-group">
          <h4 class="section-title">Select Destination Countries to enter variation pricing and delivery</h4>
          @for (country of getUnselectedCountries(); track country.iso2) {
          <mat-expansion-panel 
            [disabled]="marketBlocked(country.iso2)"
            [expanded]="isCountryExpanded(country.iso2)"
            (opened)="onPanelOpened(country.iso2)"
            (closed)="onPanelClosed(country.iso2)"
            class="mb-2"
          >
            <mat-expansion-panel-header class="py-2">
              <mat-panel-title class="country-panel-title">
                <div class="flex items-center justify-between w-full">
                  <div class="flex items-center gap-2">
                    <!-- Not enabled for the vendor, or blocked by a cross-border restriction: greyed out. -->
                    <mat-checkbox
                      [checked]="isCountrySelected(country.iso2)"
                      [disabled]="marketBlocked(country.iso2)"
                      (change)="onDestinationCountryChange($event, country.iso2)"
                      (click)="$event.stopPropagation()"
                      color="primary"
                    >
                      {{ country.name }} ({{ country.currency }})
                    </mat-checkbox>
                    @if (marketBlocked(country.iso2)) {
                    <span class="text-sm text-gray-500">{{ marketBlockText(country.iso2) }}</span>
                    }
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            @if (isCountrySelected(country.iso2)) {
            <div class="country-section py-3" [formGroupName]="country.iso2">
              <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Display Price</mat-label>
                  <input matInput formControlName="displayPrice" type="number"
                    [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                  @if (isRequestQuoteControl?.value) {
                    <mat-hint class="text-amber-600">Not Applicable</mat-hint>
                  }
                  <mat-error *ngIf="shouldShowError(countrySpecificForm.get(country.iso2)?.get('displayPrice') || null)">
                    {{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get('displayPrice') || null) }}
                  </mat-error>
                </mat-form-field>

                <!-- Delivery charge and the walk-in switch sit together: ticking it
                     zeroes and disables the charge, so they read as one control
                     rather than two that happen to be near each other. -->
                <div class="flex items-start gap-3">
                  <div class="flex-1 min-w-0">
                @if (deliveryZonesFor(country.iso2).length > 0) {
                <!-- US / MY: charged by the customer's shipping-address state, per zone. -->
                <div class="flex flex-col gap-1">
                  @for (z of deliveryZonesFor(country.iso2); track z.zone) {
                  <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
                    <mat-label>{{ z.label }}</mat-label>
                    <input matInput [formControlName]="zoneControlName(z.zone)" type="number"
                      [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                    <mat-hint>{{ isRequestQuoteControl?.value ? 'Not Applicable' : z.states }}</mat-hint>
                    <mat-error *ngIf="shouldShowError(countrySpecificForm.get(country.iso2)?.get(zoneControlName(z.zone)) || null)">
                      {{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get(zoneControlName(z.zone)) || null) }}
                    </mat-error>
                  </mat-form-field>
                  }
                </div>
                } @else {
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Delivery Charge</mat-label>
                  <input matInput formControlName="deliveryCharge" type="number"
                    [placeholder]="isRequestQuoteControl?.value ? 'Not Applicable' : ''" />
                  @if (isRequestQuoteControl?.value) {
                    <mat-hint class="text-amber-600">Not Applicable</mat-hint>
                  }
                  <mat-error *ngIf="shouldShowError(countrySpecificForm.get(country.iso2)?.get('deliveryCharge') || null)">
                    {{ getErrorMessage(countrySpecificForm.get(country.iso2)?.get('deliveryCharge') || null) }}
                  </mat-error>
                </mat-form-field>
                }
                  </div>
                  <mat-checkbox formControlName="walkInOnly" class="mt-3 shrink-0">
                    Walk in Only
                  </mat-checkbox>
                </div>

                <!-- Transhipper markup is set per product option, below. -->
              </div>

              <div class="mt-3">
                <div class="flex justify-between items-center mb-2">
                  <span class="text-sm font-medium">Product Options</span>
                  <span class="text-xs text-gray-500">(At least one required)</span>
                </div>
                <div class="product-options">
                  <fh-product-options
                    [formArray]="getProductOptionsArray(country.iso2)"
                    [markupForSize]="markupForSize(country.iso2)"
                    (addOption)="addProductOption(country.iso2)"
                    (removeOption)="removeProductOption(country.iso2, $event)"
                  >
                  </fh-product-options>
                </div>
              </div>
            </div>
            }
          </mat-expansion-panel>
          }
        </div>
        }
      </mat-accordion>
      }
      }
    </div>
  </div>
</div>
